import {createRouter, createWebHashHistory} from 'vue-router';
import {ElNotification} from 'element-plus';
import config from "@/config"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import tool from '@/utils/tool';
import systemRouter from './systemRouter';//系统路由
import formRouter from './formRouter';//表单链接路由
import dashboardRouter from './dashboardRouter';//仪表盘链接路由
import userRoutes from '@/config/route';
import {beforeEach, afterEach} from './scrollBehavior';
import loadingRouter from './loadingRouter';
const routes = [...systemRouter, ...formRouter, ...dashboardRouter];

//系统特殊路由
const routes_404 = {
	path: "/:pathMatch(.*)*",
	hidden: true,
	component: () => import(/* webpackChunkName: "404" */ '@/layout/other/404'),
}
let routes_404_r = () => {
}

const router = createRouter({
	history: createWebHashHistory(),
	routes: routes
})

//设置标题
document.title = config.APP_NAME

//判断是否已加载过动态/静态路由
var isGetRouter = false;

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	//动态标题
	if (to.meta.from && to.meta.from === 'ym') {
		document.title = to.meta.title ? `${to.meta.title} - 源码工场` : `源码工场`
	} else {
		document.title = to.meta.title ? `${to.meta.title} - ${config.APP_NAME}` : `${config.APP_NAME}`
	}
	const url = to.path.split('/')[1]
	let token = tool.cookie.get("TOKEN");
	if (to.path === "/login") {
		//删除路由(替换当前layout路由)
		router.addRoute(routes[0])
		//删除路由(404)
		routes_404_r()
		isGetRouter = false;
		next();
		return false;
	}
	if (routes.findIndex(r => r.path === to.path) >= 0) {
		next();
		return false;
	}
	// 判断如果没有token 如果打开的是公开发布的页面url就直接放行跳转到目标页面，不需要判断登陆状态
	if (!token) {
		if(url === '/download' || url === '/downloadapp' || url === 'formshare' || url === 'formquery' || url === 'dashboardlink' || url === 'document-shareLink' || url === 'l' || url === 'generateLink'|| url === 'financialDiagnosis'){
			next()
		}else{
			next({
				path: '/login'
			});
		}
		return false;
	}
	//整页路由处理
	if (to.meta.fullpage) {
		to.matched = [to.matched[to.matched.length - 1]]
	}
	//加载动态/静态路由
	if (!isGetRouter) {
		loadingRouter()
		if (to.matched.length === 0) {
			router.push(to.fullPath);
		}
		routes_404_r = router.addRoute(routes_404)
		isGetRouter = true;
	}
	if(beforeEach(to, from,next)){
		next();
	}
});


router.afterEach((to, from) => {
	afterEach(to, from)
	NProgress.done()
});

router.onError((error) => {
	NProgress.done();
	// 发版导致路由错误重新刷新
	window.location.reload();
	// ElNotification.error({
	// 	title: '路由错误',
	// 	message: error.message
	// });
});

//入侵追加自定义方法、对象
router.sc_getMenu = () => {
	let apiMenu = tool.data.get("MENU") || []
	let userInfo = tool.data.get("USER_INFO")
	let userMenu = treeFilter(userRoutes, node => {
		return node.meta.role ? node.meta.role.filter(item => userInfo.role.indexOf(item) > -1).length > 0 : true
	})
	var menu = [...userMenu, ...apiMenu]
	return menu
}
//过滤树
function treeFilter(tree, func) {
	return tree.map(node => ({...node})).filter(node => {
		node.children = node.children && treeFilter(node.children, func)
		return func(node) || (node.children && node.children.length)
	})
}

export default router
